module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a3"
  }, [_c('PinchInActStore'), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "correct",
    attrs: {
      "id": "eleCorrect"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner",
    class: _vm.cssLayoutID
  }, [_c('div', {
    staticClass: "toparea-image"
  }, [_c('div', {
    staticClass: "img-wrapper",
    attrs: {
      "ondragstart": "return false"
    },
    on: {
      "touchstart": function($event) {
        return _vm.onTouchStart()
      },
      "touchend": function($event) {
        return _vm.onTouchEnd()
      },
      "touchmove": function($event) {
        return _vm.onTouchEnd()
      },
      "mousedown": function($event) {
        return _vm.$emit('hintMouseDown', $event)
      },
      "mouseup": function($event) {
        return _vm.$emit('hintMouseUp', $event)
      },
      "mousemove": function($event) {
        return _vm.$emit('hintMouseMove', $event)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImage),
      expression: "showImage"
    }],
    attrs: {
      "src": _vm.qImage
    }
  })])]), _vm._v(" "), _c('CommonAct', {
    attrs: {
      "pathstep": _vm.pathstep,
      "activeType": _vm.activeType,
      "actChoice": true,
      "horizontalRow": true,
      "answerAct": _vm.currentData,
      "isShowTextsParent": _vm.isShowTextsParent,
      "isShowVoicesParent": _vm.isShowVoicesParent,
      "changeEndAct": _vm.changeEndAct,
      "scriptSystems": _vm.scriptSystems,
      "isCompleteParent": _vm.isCompleteParent,
      "isActivesParent": _vm.isActivesParent,
      "changeActives": _vm.changeActives,
      "needsSwiper": false,
      "isScrollIconVisible": _vm.isScrollIconVisible
    },
    on: {
      "actCorrect": _vm.recieveActCorrect,
      "actInCorrect": _vm.recieveActInCorrect,
      "audioPause": function($event) {
        return _vm.audioPause()
      },
      "updateLearnedGroup": function($event) {
        return _vm.$emit('updateLearnedGroup')
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5c058a8a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-5c058a8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/A3.vue
// module id = 870
// module chunks = 1